module.exports = __webpack_public_path__ + "assets/img/mutton_chop.ff8e0400.png";